import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/admin/printers/$id/edit")({
  parseParams(params) {
    return z.object({ id: z.coerce.number().int().positive() }).parse(params);
  },
});
